'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'list-check';
var width = 512;
var height = 512;
var aliases = ["tasks"];
var unicode = 'f0ae';
var svgPathData = 'M139.7 69.8c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L60.7 98.8 41 79C31.6 69.7 16.4 69.7 7 79S-2.3 103.6 7 113l40 40c5 5 12 7.6 19.1 6.9s13.5-4.3 17.6-10.1l56-80zm0 160c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L60.7 258.8 41 239c-9.4-9.4-24.6-9.4-33.9 0S-2.3 263.6 7 273l40 40c5 5 12 7.6 19.1 6.9s13.5-4.3 17.6-10.1l56-80zM192 96c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L216 72c-13.3 0-24 10.7-24 24zm0 160c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24zM160 416c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faListCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;